<section class="comments" aria-labelledby="comments-title">
  <h3 id="comments-title" class="comments-title">Comments</h3>
  <p class="comments-sub">
    Notes on this test case. Visible to your team and to supervisors on the Insights failures view.
  </p>

  @switch (loadState()) {
    @case ('loading') {
      <p class="comments-muted">Loading comments…</p>
    }
    @case ('error') {
      <div class="comments-error" role="alert">
        <span>Couldn't load comments.</span>
        <button type="button" class="btn btn-ghost btn-sm" (click)="retry()">Retry</button>
      </div>
    }
    @default {
      @if (visibleComments().length === 0) {
        <p class="comments-muted comments-empty">No comments yet</p>
      } @else {
        <ol class="comment-list">
          @for (c of visibleComments(); track c.testCaseCommentId) {
            <li class="comment">
              <span class="avatar size-30" [class.is-you]="isMine(c)" aria-hidden="true">{{
                initialsFor(c)
              }}</span>
              <div class="comment-main">
                <div class="comment-meta">
                  <span class="comment-author">{{ c.userName }}</span>
                  <time
                    class="comment-time"
                    [attr.datetime]="c.createdOnUtc"
                    [title]="c.createdOnUtc | date: 'medium'"
                    >{{ timeLabel(c) }}</time
                  >
                </div>
                <!-- Plain text by design: interpolated, never [innerHTML] or <markdown>. -->
                <p class="comment-body">{{ c.body }}</p>
              </div>
            </li>
          }
        </ol>
      }
    }
  }

  <div class="comment-composer">
    <span class="avatar size-30 is-you" aria-hidden="true">{{ myInitials() }}</span>
    <div class="composer-main">
      <textarea
        #composer
        class="form-textarea composer-input"
        rows="3"
        aria-label="Add a comment"
        placeholder="Add a comment or note about this test…"
        [attr.maxlength]="maxLength"
        [value]="draft()"
        (input)="onInput($event)"
      ></textarea>
      <div class="composer-actions">
        <button
          type="button"
          class="btn btn-primary composer-post"
          [disabled]="!canPost()"
          [attr.aria-busy]="isPosting()"
          (click)="post()"
        >
          {{ isPosting() ? 'Posting…' : 'Post comment' }}
        </button>
      </div>
    </div>
  </div>
</section>
